import { useMediaQuery } from "native-base";

export default function useIsLargeScreen() {
  const [isLargeScreen] = useMediaQuery({
    minWidth: 768,
  });
  return isLargeScreen;
}
